export const environment = {
  production: true,
  service_url:    '/wv_service/initData/',
  postalCode_url: '/wv_service/postalCode/',
  submit_url:     '/wv_service/submit',
  email_url:      '/wv_service/email'
};
